import {apiClient} from '../client'
import handleError from '../../utilities/api-helpers/handleError'

export const fetchProducts = async () => {
  const {products} = await apiClient.get('products').catch(handleError)
  return {products}
}
